import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../redux-stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCollaborationsTasksThunk } from '../../redux-stores/slices/CollaborationsTasksSlice';
import { generateUniqueKey } from '../../utils/helpers';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { colors } from '../../constants/constants';
const influencerPendingTasksFilters = { status: 'ongoing', page: 1, assignee: 'influencer', limit: 50 }
const filterId = generateUniqueKey(influencerPendingTasksFilters, ['page']);

const PendingSteps: React.FC = () => {

    const dispatch: AppDispatch = useDispatch();

    const collaborationsData = useSelector((state: RootState) => state.collaborationTasks.filtered_lists[filterId]);
    const collaborations = collaborationsData?.list ?? [];
    const loading = useSelector((state: RootState) => state.collaborationTasks.loading);

    const fetchPendingStepTasks = async () => {
        dispatch(fetchCollaborationsTasksThunk({ filters: influencerPendingTasksFilters }));
    }

    useEffect(() => {
        fetchPendingStepTasks();
    }, [])

    if (loading || collaborations.length === 0) return null;

    return (
        <div className='pending-actions-card'>
            <h6 className="m-0 title">Pending Tasks</h6>
            <Swiper pagination={true} modules={[Autoplay]} autoplay={{ delay: 2000, disableOnInteraction: false }}  className="mySwiper pending-tasks-swiper pb-4" spaceBetween={10} slidesPerView={1.1}>
                {
                    collaborations.map((collaboration, index) => {

                        const activeStep = [...(collaboration.active_steps ? collaboration.active_steps.filter((step) => step.can_process) : [])].sort((a, b) => a.sort_order - b.sort_order)[0];

                        return (
                            <SwiperSlide key={index}>
                                <div className="pending-task-card position-relative">
                                    <div className="d-flex gap-2 w-95">
                                        <div className="bg-image bgc-content" style={{ backgroundImage: `url(${collaboration.campaign.hero_img_url})`, height: '2.75rem', width: '2.75rem', borderRadius: '0.5rem' }}></div>
                                        <div className="d-flex flex-column gap-1 align-items-start justify-content-center w-75">
                                            <h6 className="pending-task-title text-truncate w-100 text-start m-0">{collaboration.campaign.name}</h6>
                                            <Link to={{ pathname: `/collaborations/${collaboration.campaign.uuid}/milestone/${collaboration.active_milestone.id}` }} className="pending-task-subtitle w-100 text-start text-truncate">{activeStep.gig_step.cta_text ?? 'Take Action'}</Link>
                                        </div>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.96967 8.46967C10.2626 8.17678 10.7374 8.17678 11.0303 8.46967L14.0303 11.4697C14.3232 11.7626 14.3232 12.2374 14.0303 12.5303L11.0303 15.5303C10.7374 15.8232 10.2626 15.8232 9.96967 15.5303C9.67678 15.2374 9.67678 14.7626 9.96967 14.4697L12.4393 12L9.96967 9.53033C9.67678 9.23744 9.67678 8.76256 9.96967 8.46967Z" fill={colors.primary} />
                                    </svg>
                                </div>
                            </SwiperSlide>
                        ) 
                    })
                }
            </Swiper>
        </div>
    )
}

export default PendingSteps